import { BasketballSwitchRequestSwitchType } from '@hefe/models';
import { BasketballSwitchRequestsSlice, ModalsSlice } from '@hefe/store';
import { formatDateTime } from '@hefe/utils';
import { Col, Row, Space, Spin, Typography } from 'antd';
import { t } from '@hefe/i18n';
import { trimEnd } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../store/store';
import CustomForm from '../../core/components/form/custom-form';

interface SwitchRequestsCreateRefereeGameFormProps {
  userId: number;
}

export default function SwitchRequestsCreateRefereeGameForm(
  props: SwitchRequestsCreateRefereeGameFormProps
) {
  const { userId } = props;
  const dispatch = useAppDispatch();
  const options = useSelector(
    BasketballSwitchRequestsSlice.possibleRefereeGamesSelector
  )[userId];
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    fetchGames();
  }, [userId]);

  const fetchGames = () => {
    if (options) {
      return;
    }

    setLoading(true);
    dispatch(
      BasketballSwitchRequestsSlice.fetchBasketballRefereePossibleGames(userId)
    )
      .unwrap()
      .catch(() => null)
      .finally(() => setLoading(false));
  };

  const onSubmit = (values: any) => {
    const gameId = values.game_id;
    const setModalLoading = ModalsSlice.modalsActions.setModalLoading;
    const closeModal = ModalsSlice.modalsActions.closeModal;

    dispatch(setModalLoading(true));
    dispatch(
      BasketballSwitchRequestsSlice.createBasketballSwitchRequest({
        event_id: gameId,
        is_game: true,
        note: values.note,
        user_id: props.userId,
        switch_type: BasketballSwitchRequestSwitchType.REFEREE,
      })
    )
      .unwrap()
      .then(() => dispatch(closeModal()))
      .catch(() => null)
      .finally(() => dispatch(setModalLoading(false)));
  };

  if (isLoading) {
    return <Spin />;
  }

  return (
    <Row gutter={[0, 20]}>
      <Col xs={24}>
        <Typography.Text>
          {t('questions.create_switch_request')}
        </Typography.Text>
      </Col>
      <Col xs={24}>
        <CustomForm
          formId={`switch-request-form-create-referee-game-${userId}`}
          fields={[
            {
              label: t('games.singular'),
              name: 'game_id',
              type: 'select',
              initalValue: null,
              selectOptions: options || [],
              rules: [
                {
                  required: true,
                  message: t('form_errors.select_value'),
                },
              ],
            },
            {
              label: t('note'),
              name: 'note',
              type: 'text',
              rules: [],
            },
          ]}
          onSubmit={onSubmit}
        />
      </Col>
    </Row>
  );
}
